import * as _ from 'lodash';

export const getUsers = ({ users }) => [
  ..._.get(users, 'invites', []),
  ..._.get(users, 'users', []),
];
